import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}

import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { baseInput, baseTextarea } from "@/common/components";

import { MethodGroupPayloadType } from "@/common/types/method/method-group";


export default /*@__PURE__*/_defineComponent({
  __name: 'method-group',
  props: {
    data: {},
    title: {},
    width: { default: "100%" }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_PAYLOAD = {
  status: "ACTIVE",
  name: "",
  description: null,
};

const payload = ref<MethodGroupPayloadType>({ ...DEFAULT_PAYLOAD });

function update() {
  emit("update-data", payload.value);
}

watchEffect(() => {
  if (props.data) {
    payload.value = {
      ...DEFAULT_PAYLOAD,
      ...props.data,
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (update()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 4))
}
}

})